var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, EventEmitter } from '@angular/core';
import { config } from '../../../../config/config';
import { BaseComponent } from '../../../common/components/base.component';
import { popupCenter } from '../../../common/extensions/browser/browser.extensions';
import { ShareService } from '../../../services/share.service';
var SocialShareComponent = /** @class */ (function (_super) {
    __extends(SocialShareComponent, _super);
    function SocialShareComponent() {
        var _this = _super.call(this) || this;
        _this.appearance = 'normal'; // normal | white | rounded
        _this.showTip = true;
        _this.link = '';
        _this.type = null;
        _this.onShareToFB = new EventEmitter();
        _this.onShareToTweet = new EventEmitter();
        _this.onShareEmail = new EventEmitter();
        return _this;
    }
    SocialShareComponent.prototype.ngAfterContentInit = function () {
        this.setItemInfo();
    };
    SocialShareComponent.prototype.onKeyPress = function ($event, social) {
        if ($event && $event.key === 'Enter') {
            if (social === 'facebook') {
                this.shareToFacebook();
            }
            else if (social === 'tweet') {
                this.tweetEvent();
            }
            else if (social === 'email') {
                this.mailEvent();
            }
        }
    };
    SocialShareComponent.prototype.shareToFacebook = function () {
        this.setItemInfo();
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.link, 'facebook-share-dialog', 'width=800,height=600');
        // let params = <ShareDialogParams>{
        //   method: 'share',
        //   href: this.link,
        //   // quote: (this.item.title || this.item.name) + ' - ' + (this.item.description || (this.item as any).about || '(No description)'),
        //   quote: this.item.title || this.item.name,
        //   picture: this.item.cover ? this.item.cover.source : null,
        // };
        // FB.ui(params, () => {});
        this.onShareToFB.emit();
    };
    SocialShareComponent.prototype.tweetEvent = function () {
        this.setItemInfo();
        var shareLink = config.eventShare.tweet
            .replace('${text}', this.item.name)
            .replace('${url}', encodeURIComponent(this.link));
        popupCenter(shareLink);
        this.onShareToTweet.emit();
    };
    SocialShareComponent.prototype.mailEvent = function () {
        this.setItemInfo();
        var content = this.item.startTime
            ? ShareService.toMailableEvent(this.item.hubName, this.item, this.link)
            : ShareService.toMailablePlace(this.item.hubName, this.item, this.link);
        if (this.isMobile) {
            window.open(content);
        }
        else {
            window.location.href = content;
        }
        this.onShareEmail.emit();
    };
    SocialShareComponent.prototype.setItemInfo = function () {
        var _this = this;
        setTimeout(function () {
            _this.type = _this.item.startTime ? 'event' : 'place';
            _this.link = _this.item.startTime
                ? _this.item.eventLink
                : _this.item.hostLink || _this.item.hostGoogleLink || _this.item.hostFacebookLink;
            _this.link = _this.link || window.location.href;
        });
    };
    return SocialShareComponent;
}(BaseComponent));
export { SocialShareComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/social.share/social.share.component.ts.pre-build-optimizer.js